import React from 'react';

import PropTypes from 'prop-types';
import { Link } from 'react-router';

const ContactUsLink = (props) => {
    const {
        children,
        className = 'link-primary',
    } = props;

    return (
        <Link to="/contact-us" className={className}>{children}</Link>
    );
};

ContactUsLink.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default ContactUsLink;
